<div class="row mb-2">
  <div class="col-7 input-trend-search">
    <input class="form-control" [placeholder]="'attendance.waTemplate.searchTemplatePlaceholder' | translate" [formControl]="searchControl"
      (input)="filterTemplates($event)" [readonly]="selectedTemplateId" />
    <span class="mdi mdi-magnify search-icon ml-2"></span>
  </div>
  <div class="col-5 btn-group trend-button">
    <button [matMenuTriggerFor]="statusMenu" type="submit"
      class="btn btn-primary fw-bold mdi mdi-filter-variant dropdown-toggle me-2" [disabled]="selectedTemplateId">
      <span>{{selectedStatus ? translateTemplateStatus(selectedStatus) : ('attendance.waTemplate.status' | translate)}}</span>
    </button>
    <mat-menu #statusMenu="matMenu">
      <button mat-menu-item (click)="filterByStatus('')">{{ 'attendance.waTemplate.all' | translate }}</button>
      @for (status of statuses; track $index) {
      <button mat-menu-item (click)="filterByStatus(status.value)">
        {{ status.label }}
      </button>
      }
    </mat-menu>
     <button [matMenuTriggerFor]="categoryMenu" type="submit"
      class="btn btn-primary fw-bold mdi mdi-filter-variant dropdown-toggle me-2" [disabled]="selectedTemplateId">
      <span>{{selectedCategory ? translateTemplateCategory(selectedCategory) : ('attendance.waTemplate.category' | translate)}}</span>
    </button>
    <mat-menu #categoryMenu="matMenu">
      <button mat-menu-item (click)="filterByCategory('')">{{ 'attendance.waTemplate.all' | translate }}</button>
      @for (category of categories; track $index) {
      <button mat-menu-item (click)="filterByCategory(category.value)">
        {{ category.label }}
      </button>
      }
    </mat-menu>
    <button class="btn btn-success fw-bold" (click)="cleanCacheTemplates()">
      <i class="ri-refresh-line"></i>
      {{ 'attendance.waTemplate.refreshTemplates' | translate }}
    </button>
  </div>
</div>
@if (loading) {
<li class="is-loading">
  <mat-spinner [diameter]="45" />
  <p class="h5">{{ 'attendance.waTemplate.loadingTemplates' | translate }}</p>
</li>
} @else {

@if (templates?.length === 0) {
<empty-records-component [icon]="'mdi mdi-alert-circle-outline'" [message]="'attendance.waTemplate.noTemplatesFound' | translate"
  [subMessage]="'attendance.waTemplate.noTemplatesFoundHint' | translate" />
} @else {

<div class="card-body table-responsive custom-rounded-table">
  <table class="table table-hover table-centered mb-0">
    <thead>
      <tr>
        <th class="text-primary-emphasis" style="width: 60%">{{ 'attendance.waTemplate.model' | translate }}</th>
        <th class="text-primary-emphasis">{{ 'attendance.waTemplate.status' | translate }}</th>
        <th class="text-primary-emphasis">{{ 'attendance.waTemplate.category' | translate }}</th>
        <th class="text-primary-emphasis">{{ 'attendance.waTemplate.language' | translate }}</th>
        <th class="sr-only">&nbsp;</th>
      </tr>
    </thead>
    <tbody>
      @for(template of templates; track template.name) {
      <tr role="row">
        <td>
          <strong>{{ template.name }}</strong><br />
          <span class="text-muted" [matTooltip]="getBodyText(template)">
          {{ getBodyText(template) | slice : 0 : 80 }}
          </span>
        </td>
        <td class="text-wrap">
          <span
              class="badge text-capitalize font-14"
              [ngClass]="{
                'bg-success':template.status === 'APPROVED',
                'bg-warning': template.status === 'PENDING',
                'bg-danger': template.status === 'REJECTED',
              }"
            >
              {{ translateTemplateStatus(template.status) }}
            </span>
        </td>
        <td>
          @switch (template.category) {
          @case ('MARKETING') {
          {{ 'attendance.waTemplate.categoryMarketing' | translate }}
          }
          @case ('UTILITY') {
          {{ 'attendance.waTemplate.categoryUtility' | translate }}
          }
          @case ('AUTHENTICATION') {
          {{ 'attendance.waTemplate.categoryAuthentication' | translate }}
          }
          @default {
          {{ template.category }}
          } }
        </td>
        <td>
          @switch (template.language) {
          @case ('pt_BR') {
          <span class="d-flex align-items-center gap-2">
            <img width="20" src="../../../../assets/icons/br.svg" [alt]="'attendance.waTemplateMessage.languageAltPt' | translate" />
            <strong>{{ 'attendance.waTemplateMessage.languagePtBR' | translate }}</strong>
          </span>
          }
          @case ('en') {
          <span class="d-flex align-items-center gap-2">
            <img width="20" src="../../../../../../../assets/icons/us.svg" [alt]="'attendance.waTemplateMessage.languageAltEn' | translate" />
            <strong>{{ 'attendance.waTemplateMessage.languageEnUS' | translate }}</strong>
          </span>
          }
          @case ('en_US') {
          <span class="d-flex align-items-center gap-2">
            <img width="20" src="../../../../../../../assets/icons/us.svg" [alt]="'attendance.waTemplateMessage.languageAltEn' | translate" />
            <strong>{{ 'attendance.waTemplateMessage.languageEnUS' | translate }}</strong>
          </span>
          }
          @case ('pt_PR') {
          <span class="d-flex align-items-center gap-2">
            <img width="20" src="../../../../../../../assets/icons/pt.svg" [alt]="'attendance.waTemplateMessage.languageAltPtPT' | translate" />
            <strong>{{ 'attendance.waTemplateMessage.languagePtPT' | translate }}</strong>
          </span>
          }
          @case ('pt_PT') {
          <span class="d-flex align-items-center gap-2">
            <img width="20" src="../../../../../../../assets/icons/pt.svg" [alt]="'attendance.waTemplateMessage.languageAltPtPT' | translate" />
            <strong>{{ 'attendance.waTemplateMessage.languagePtPT' | translate }}</strong>
          </span>
          }
          @default {
          {{ template.language }}
          }
          }
        </td>
        <td align="right" class="custom-button-select">
          <button class="btn btn-dark btn-sm" (click)="showTemplateDetails(template)">
            <i class="ri-check-line"></i>
            {{ 'attendance.waTemplate.select' | translate }}
          </button>
        </td>
      </tr>
      }
    </tbody>
  </table>
</div>
}
}